import React from "react";

const toLatLng = v => {
  if (v && (v.latitude !== undefined || v.longitude !== undefined)) return { lat: v.latitude, lng: v.longitude };
  return { lng: "", lat: "" };
};

export default function CoordinateField({ field, value, onChange, labels = {} }) {
  const { lat, lng } = toLatLng(value);
  const emit = (nextLat, nextLng) => {
    if (nextLat === "" && nextLng === "") return onChange(field.name, null);
    onChange(field.name, { latitude: Number(nextLat), longitude: Number(nextLng) });
  };
  return (
    <div className="mp-form-group">
      <label className="mp-form-label">{field._label}</label>
      <div className="pt-coord-row">
        <input type="number" step="any" className="mp-form-input" placeholder={labels.lat}
               value={lat} onChange={e => emit(e.target.value, lng)} />
        <input type="number" step="any" className="mp-form-input" placeholder={labels.lng}
               value={lng} onChange={e => emit(lat, e.target.value)} />
      </div>
    </div>
  );
}
